module.exports = require('./lib/Granim.js');



//////////////////
// WEBPACK FOOTER
// ./~/granim/index.js
// module id = 8
// module chunks = 0